module.exports = __webpack_public_path__ + "img/content_image3.91140168.png";